import * as React from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/fr-ch';
import "react-big-calendar/lib/css/react-big-calendar.css";
import  {useState, useEffect} from "react";
import {Box,Stack} from "@mui/material";
import TodayEventsHeader from "./TodayEventsHeader"
import TodayEventsCardList from "./TodayEventsCardList";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";
import parse from "html-react-parser";
import {useNavigate} from "react-router-dom";


const localizer = momentLocalizer(moment);

const mapping = (event) => {
    console.log(new Date(event.start_date));
    return {
        'id': event.id,
        'title': parse(event.title.text),
        'start': new Date(event.start_date * 1000) ,
        'end': new Date(event.end_date * 1000),
        'theEvent': event
    };
}

const MyCalendar = ({events, setTabValue, setEventToSee, setScreenNumberDefault}) => {
    const navigate = useNavigate();
    const [list,setList] = useState([]);
    const [startDate, setStartDate] = useState(moment());
    const mapData = (events) => {
        const oldEvents = events.old ? events.old.map(mapping):[];
        const newEvents = events.new ? events.new.map(mapping):[];
        const nowEvents = events.now ? events.now.map(mapping):[];
        return [...oldEvents, ...newEvents, ...nowEvents];
    }
    const {mode} = useDarkMode();
    const {police} = usePoliceMode();

    useEffect(() => {
        const mapping = async () => {
            const data = await(mapData(events));
            console.log(data)
            setList(data);
        }
        mapping();
    },[events]);

    const handleSelectSlot = ({start}) => {
        console.log(start);
        setStartDate(start);
    };


    return (
        <Stack
            direction="row"
            justifyContent="left"
            alignItems="stretch"
            spacing={{xs : 0, md : 0, lg : 0.5}}
            flexWrap={"wrap"}
        >
            <Box sx={{backgroundColor: mode.settings.cardBackgroundColor, padding:1,width:{xs : '100%', md : '100%', lg : '63%'}}}
                 id={'big-calendar'}
                 className={mode.darkMode ? 'big-calendar-dark' : ''}
            >
                <Calendar
                    views={["month","agenda"]}
                    selectable
                    localizer={localizer}
                    events={list}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 500 }}
                    messages={{
                        next: "Suivant",
                        previous: "Précedent",
                        today: "Aujourd'hui",
                        month: "Mois",
                        week: "Semaine",
                        day: "Jour",
                    }}
                    onSelectSlot={handleSelectSlot}
                    onSelectEvent={event =>  {console.log('event', event); setTabValue(5); setEventToSee(event.theEvent); setScreenNumberDefault(2)}}
                    className= {police.normalMode ? "" : "community-calendar-dyslexic"}
                />
            </Box>
            <Box sx={{backgroundColor: mode.settings.cardBackgroundColor ,width:{xs : '100%', md : '100%', lg : '35%'}}}>
                <TodayEventsHeader startDate={startDate}></TodayEventsHeader>
                <TodayEventsCardList
                    events={events}
                    startDate={startDate}
                    setTabValue={setTabValue}
                    setEventToSee={setEventToSee}
                    setScreenNumberDefault={setScreenNumberDefault}
                >
                </TodayEventsCardList>
            </Box>
        </Stack>
    )
}

export default MyCalendar;
